const subscribe = (state = [], action) => {
    return state;
};

export default subscribe;